import React from 'react';

import { CheckIcon, InfoCircleFilledIcon } from '@vlabs/icons';

import type { TRegionColors } from '@vlabs/monokit/shared/ui/regions-drawing';
import { CANVAS_COLORS } from '@vlabs/monokit/shared/ui/regions-drawing';

import st from './EditDepartmentGeoZoneControlPanel.module.sass';
import { useEditDepartmentGeoZoneTranslation } from '../i18n';

const COLORS: TRegionColors[] = ['positive', 'accentOrange', 'accentBlue', 'accentRed', 'alwaysBlack'];
interface EditDepartmentGeoZoneControlPanelProps {
  onChangeColor: (color: TRegionColors) => void;
  colorValue: TRegionColors;
  colors?: TRegionColors[];
}

function EditDepartmentGeoZoneControlPanel({
  onChangeColor,
  colorValue,
  colors = COLORS,
}: EditDepartmentGeoZoneControlPanelProps): React.JSX.Element {
  const { t } = useEditDepartmentGeoZoneTranslation();

  return (
    <div className={st.Root}>
      <div className={st.ColorPicker}>
        <span className={st.ColorPickerTitle}>{t('color')}</span>

        <div className={st.Colors}>
          {colors.map((color) => (
            <button
              className={st.ColorButton}
              key={color}
              onClick={() => onChangeColor(color)}
              style={{ backgroundColor: CANVAS_COLORS[color].base }}
              type="button"
            >
              {colorValue === color && (
                <CheckIcon className={st.SelectedColorIcon} />
              )}
            </button>
          ))}
        </div>
      </div>
      <div className={st.Divider} />
      <div className={st.Toast}>
        <InfoCircleFilledIcon className={st.ToastIcon} />

        <div className={st.Hint}>
          <span>{t('hint', { context: 'draw' })}</span>
          <span>{t('hint', { context: 'delete' })}</span>
        </div>
      </div>
    </div>
  );
}

export { EditDepartmentGeoZoneControlPanel };
